export default __webpack_public_path__ + "static/media/logo-lg-1440w.9a7b1fcc.avif";